/* eslint-disable react/forbid-prop-types */
import {
  VictoryChart, VictoryVoronoiContainer, VictoryTooltip, VictoryLine,
} from 'victory';
import { Card } from './styles';

import NoData from '../../../../../components/NoData';
import { AffreightmentEvolutionType, VtEvolutionType } from '../../types';

interface EvolutionVtAffreightmentaCardInterface {
  dashboardVtEvolutionData: VtEvolutionType;
  dashboardAffreightmentEvolutionData: AffreightmentEvolutionType;
  selectedWorkplace: { value: number, label: string };
}

export default function EvolutionVtAffreightmentaCard({
  dashboardVtEvolutionData,
  dashboardAffreightmentEvolutionData,
  selectedWorkplace,
}: EvolutionVtAffreightmentaCardInterface) {
  const monthsAbvMap: { [key: number]: string } = {
    1: 'Jan',
    2: 'Fev',
    3: 'Mar',
    4: 'Abr',
    5: 'Mai',
    6: 'Jun',
    7: 'Jul',
    8: 'Ago',
    9: 'Set',
    10: 'Out',
    11: 'Nov',
    12: 'Dez',
  };

  const isFirstMonth = dashboardVtEvolutionData?.length === 1
  && dashboardAffreightmentEvolutionData?.length === 1;

  const hasInfo = dashboardVtEvolutionData || dashboardAffreightmentEvolutionData;

  const showChart = !isFirstMonth && hasInfo;

  return (
    <Card>
      <div className="card-title">
        <div>Evolução das despesas VT x Fretamento</div>
      </div>

      {showChart && (
        <>
          <div className="card-main-graph">
            <VictoryChart
              height={150}
              width={300}
              padding={{
                top: 15, bottom: 30, left: 30, right: 30,
              }}
              containerComponent={(
                <VictoryVoronoiContainer
                  labels={({ datum }) => `${datum.x}, ${datum.y}`}
                  labelComponent={
                    <VictoryTooltip dy={0} constrainToVisibleArea />
                  }
                />
              )}
            >
              {dashboardVtEvolutionData && (
                <VictoryLine
                  style={{
                    data: { stroke: '#4aafff' },
                    parent: { border: 'none' },
                  }}
                  data={dashboardVtEvolutionData.map((data) => (
                    { x: `${monthsAbvMap[data.mes]}/${String(data.ano).replace('20', '')}`, y: data.custoVT }
                  ))}
                  interpolation="natural"
                  animate={{
                    duration: 3000,
                    onLoad: { duration: 5000 },
                  }}
                />
              )}

              {dashboardAffreightmentEvolutionData && (
                <VictoryLine
                  style={{
                    data: { stroke: '#006FE6' },
                    parent: { border: 'none' },
                  }}
                  data={dashboardAffreightmentEvolutionData.map((data) => (
                    { x: `${monthsAbvMap[data.mes]}/${String(data.ano).replace('20', '')}`, y: data.custoFreta }
                  ))}
                  interpolation="natural"
                  animate={{
                    duration: 4000,
                    onLoad: { duration: 6000 },
                  }}
                />
              )}

            </VictoryChart>
          </div>
          <div className="legend">
            <small className="vt">
            ● VT
            </small>
            <small className="fretamento">
            ● Fretamento
            </small>
          </div>
        </>
      )}

      {!hasInfo && (
        <NoData
          icon="emptyBox"
          label={(
            <>
            O local de trabalho
              {' '}
              <strong>{selectedWorkplace.label}</strong>
              {' '}
            não possui dados
            sobre a evolução das despesas de fretamento e VT.
            </>
          )}
        />
      )}

      {isFirstMonth && (
        <NoData
          icon="emptyBox"
          label={(
            <>
              São necessários pelo menos
              {' '}
              <strong>2 meses de serviço</strong>
              {' '}
              para exibir o gráfico
              de evolução das despesas de fretamento e VT.
            </>
          )}
        />
      )}
    </Card>
  );
}
